import AppInputField from "components/shared/FormComponents/AppInputField";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { useField } from "formik";
import { formatString } from "helpers/common";

const QuestionDiagnosis = ({ question, fieldName }) => {
  const [field] = useField(fieldName);
  const options = question?.question_radio_tag;
  const inputLabels = question?.question_dd_labels;

  return (
    <>
      <div className="radio-inputs">
        <AppRadioField
          containerClass={"d-flex align-items-center py-1"}
          options={options.map(option => ({value: option, label: formatString(option)}))}
          name={`${fieldName}.other_details.radio_tag`}
          labelStyles={{
            color: "#071E3E",
            fontSize: "12px",
            fontWeight: "500",
            fontFamily: "Proxima Nova regular",
          }}
        />
      </div>
      {field?.value?.other_details?.radio_tag === "diagnosis" && (
        <AppInputField
          name={`${fieldName}.answer`}
          placeholder={question.template}
          fieldType={"textarea"}
          rows={4}
          className="form-control rounded-3 bg-white pt-5 is-resizable-textarea"
          style={{ minHeight: "calc(8em + 0.75rem + calc(var(--bs-border-width) * 2)) !important" }}
        />
      )}
    </>
  )
}

export default QuestionDiagnosis;